// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles_overlay__TSLI1","wrapper":"styles_wrapper__CKp7X"};